import { Component, Input } from '@angular/core';
import { DetailsSection } from 'src/app/model/page/group/revision-notices/new-ndc-revision-notices-page';

@Component({
  selector: 'app-new-revision-notice-details-section',
  templateUrl: './new-revision-notice-details-section.component.html',
  styleUrls: ['./new-revision-notice-details-section.component.scss']
})
export class NewRevisionNoticeDetailsSectionComponent {
  @Input() sections: DetailsSection = {} as DetailsSection;
}
